import React, { useContext, useImperativeHandle, useState, useMemo, useRef, useEffect } from 'react';
import { Button, Modal, message, Tabs, Empty } from 'antd';
import type { SpComListType } from '../../index';
import SelectTreeV2 from './components/SelectTreeV2';
import FilterRecordList from './components/FilterRecordList';
import styles from './index.module.less';
import getShowTreeDataFromApiName from './service';
import { GetFilterTableSchema } from './effect/GetFilterTableSchema';
import { SmileOutlined } from '@ant-design/icons';

const FilterTree: React.FC<SpComListType> = function FilterTree(props) {
  console.log('FilterTree-props', props);
  const { metaConfig = {}, values = {}, onChange, _rowId, _headId, rulesMap = {}, refList } = props;
  const { freeComponentsConfig = {}, taskInfo = {}, index } = metaConfig;
  const mainModule = freeComponentsConfig && freeComponentsConfig['position-module'];
  const mainRecordValues = JSON.stringify(values && values[mainModule]);
  // const mainRecord = index || index === 0 ? mainRecordValues[index] : mainRecordValues;

  const [mainRecord, setMainRecord] = useState<any>({});
  // 树图数据
  const [showTreeData, setShowTreeData] = useState<any>();
  const [showTreeList, setShowTreeList] = useState<any>([]);
  // 树图选中
  const [activeKey, setActiveKey] = useState<string>();
  const [activeData, setActiveData] = useState<any>();

  // 定制化列表塞默认值
  const [defualtData, setDefaultData] = useState<any>({});

  const [changeData, setChangeData] = useState<string>('{}');

  const getShowTreeDataFromApi = async (data: any) => {
    const resData = await getShowTreeDataFromApiName(data, freeComponentsConfig.treeApi);
    setShowTreeData(resData.treeData);
    setShowTreeList(resData.treeList);
  };
  useMemo(() => {
    const dataSource = mainRecordValues || '{}';
    const newRecordData = JSON.parse(dataSource);
    const newMainRecord = index || index === 0 ? newRecordData[index] : newRecordData;
    setMainRecord(newMainRecord);
    const reField = freeComponentsConfig?.apiField?.split(',');
    const newData: any = JSON.parse(changeData);
    reField.map((el: string) => {
      newData[el] = newMainRecord[el];
    });
    const newDataSt = JSON.stringify(newData);
    if (newDataSt !== changeData) {
      setChangeData(newDataSt);
      getShowTreeDataFromApi(newMainRecord);
    }
  }, [mainRecordValues]);

  const onSelectNodeChange = (data: any, selected: boolean) => {
    if (!selected) {
      setActiveKey(data && data[freeComponentsConfig?.treeRelationField]);
      setActiveData(data);
    } else {
      setActiveKey(undefined);
      setActiveData(undefined);
    }
  };

  const { filterTableSchema } = GetFilterTableSchema({
    config: freeComponentsConfig,
    schemaTree: taskInfo.relationTree,
    metaConfig,
    values,
    rulesMap,
  });

  useEffect(() => {
    const newAllData = {
      ...values,
    };
    Object.keys(defualtData).forEach((el: any) => {
      newAllData[el] = defualtData[el];
    });
    onChange && onChange(newAllData);
  }, [defualtData]);

  return (
    <>
      <div className={styles.line_box}>
        {
          showTreeData && (
            <div className={styles.tree_box}>
              <SelectTreeV2
                data={showTreeData}
                onChange={setShowTreeData}
                handleNodeClick={onSelectNodeChange}
                currentSelectNode={activeData}
              />
            </div>
          )
        }
        <div className={styles.tabs_box}>
          {showTreeData && (
          <Tabs
            type="line"
            size="large"
            centered={false}
            tabPosition="top"
            keyboard={false}
          >
            {filterTableSchema.map((module: any, i) => {
              const showFlag = !(activeData?.is_bpart_classification && module.handle === 'cpart_main_material');
              return (
                showFlag ? (
                  <Tabs.TabPane tab={module?.props.tab} key={module?.props.key} forceRender>
                    {module.children?.map((m: any, ind: number) => {
                      const allValues = values ? values[module.handle] : [];
                      const value = allValues?.filter((el: any) => !_headId || el[_headId] === mainRecord[_rowId]);
                      return (
                        <FilterRecordList
                          key={ind}
                          value={value || []}
                          mainRecordValue={mainRecord}
                          showTreeList={showTreeList}
                          showTreeData={showTreeData}
                          filterProps={module.filterProps}
                          activeKey={activeKey}
                          activeData={activeData}
                          metaConfig={metaConfig}
                          _headIdField={_headId}
                          headIdData={mainRecord[_rowId]}
                          refList={refList}
                          onChange={(data: any, isDefault: boolean) => {
                            const oldData = values[module.handle] || [];
                            const newData = oldData?.filter((el: any) => el[_headId] !== mainRecord[_rowId]).concat(data);
                            if (isDefault) {
                              const newDefualtData = {
                                ...defualtData,
                                [module.handle]: newData,
                              };
                              setDefaultData(newDefualtData);
                            } else {
                              const newAllData = {
                                ...values,
                                [module.handle]: newData,
                              };
                              onChange && onChange(newAllData);
                            }
                          }}
                          {...m.props}
                        />
                      );
                    })}
                  </Tabs.TabPane>
                ) : null
              );
            })}
          </Tabs>
          )}
        </div>
      </div>
      {!showTreeData && <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}
    </>
  );
};

export default FilterTree;
